import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FamilyMemberFormModal } from '@/common/containers/Dashboard/Profile/FamilyMembers/components/FamilyMemberFormModal/FamilyMemberFormModal';
import { AnalyticsService } from '@/common/integrations/analytics/analytics.service';
import { IFamilyMember } from '@/common/integrations/menhir/employee/employee/employee.types';
import { CardAction, IconUserPlus } from '@coverflex-tech/hypernova';

export type TAddFamilyMemberBoxProps = {
  type?: IFamilyMember['type'];
  onMemberAdded?: (member: IFamilyMember) => void;
};

export const AddFamilyMemberBox = ({
  type,
  onMemberAdded,
}: TAddFamilyMemberBoxProps) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <CardAction
        title={t('dashboard.add_family_member.title')}
        onClick={() => {
          AnalyticsService.trackCustomEvent('add_child_button_clicked', {
            context: 'childcare_voucher_page',
          });
          setShowModal(true);
        }}
        icon={<IconUserPlus />}
        iconBadgeColor="accentPrimary10"
      />
      {showModal && (
        <FamilyMemberFormModal
          initialValues={{ type }}
          onClose={() => setShowModal(false)}
          onMemberAdded={onMemberAdded}
        />
      )}
    </>
  );
};
